import React from "react";
import {List} from "../modules/EmployeeManagement";

export function EmployeesListPage() {
  return (
    <List />
  );
}
